import { QarepaEnumInformation } from '@qarepa/common';

export enum GenderEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
}

export type GenderType = GenderEnum.FEMALE | GenderEnum.MALE;

export const GenderArray = [GenderEnum.FEMALE, GenderEnum.MALE];

export const GenderInfo: QarepaEnumInformation<GenderEnum> = {
  [GenderEnum.FEMALE]: {
    name: $localize`Mujer`,
  },
  [GenderEnum.MALE]: {
    name: $localize`Hombre`,
  },
};
